import axios from 'axios';
import { Tower } from '../types/towerTypes';
import apiClient from './apiClient';

export interface TowerWithProgress {
    tower: Tower;
    cumulativePercentage: number;
}

/** Identificadores de las torres que no se pueden eliminar, agrupados por motivo. */
export interface TowerUsage {
    withDailyReports: number[];
    withActivityAssignments: number[];
}

export const getTowersWithProgress = async (projectId: number, activityId: number): Promise<TowerWithProgress[]> => {
    try {
        const response = await apiClient.get(`/Towers/project/${projectId}/activity/${activityId}/with-progress`);
        return response.data;
    } catch (error) {
        console.error('Error al obtener torres con progreso:', error);
        throw new Error('Error al obtener el historial de las torres.');
    }
};

// Obtener todas las torres asociadas a un proyecto específico
export const getTowersByProjectId = async (projectId: number, road?: string): Promise<Tower[]> => {
  try {
      const response = await apiClient.get(`/Towers/project/${projectId}`, {
          params: road ? { road } : {},
      });
      return response.data;
  } catch (error) {
      console.error('Error al obtener las torres:', error);
      throw new Error('Error al obtener las torres.');
  }
};

// Agregar una nueva torre asociada a un proyecto
export const addTower = async (tower: Tower): Promise<Tower> => {
    try {
        const response = await apiClient.post(`/add`, tower);
        return response.data;
    } catch (error) {
        console.error('Error al agregar la torre:', error);
        throw new Error('Error al agregar la torre.');
    }
};

// Actualizar una torre existente
export const updateTower = async (towerId: number, updatedTower: Tower): Promise<Tower> => {
    try {
        const response = await apiClient.put(`/Towers/${towerId}`, updatedTower);
        return response.data;
    } catch (error) {
        console.error('Error al actualizar la torre:', error);
        throw new Error('Error al actualizar la torre.');
    }
};

// Eliminar una torre
export const deleteTower = async (towerId: number): Promise<void> => {
    // Se deja propagar el error original para poder leer el mensaje del backend
    // (por ejemplo, torre con reportes diarios asociados).
    await apiClient.delete(`/Towers/${towerId}`);
};

/**
 * Torres del proyecto que no se pueden eliminar, agrupadas por motivo.
 * El borrado de torres es físico, así que cualquier referencia lo impide.
 */
export const getTowerUsage = async (projectId: number): Promise<TowerUsage> => {
    try {
        const response = await apiClient.get(`/Towers/usage/${projectId}`);
        return response.data;
    } catch (error) {
        console.error('Error al obtener el uso de las torres:', error);
        return { withDailyReports: [], withActivityAssignments: [] };
    }
};

export const downloadTowerFormat = async (projectId: string) => {
  try {
    const response = await apiClient.get(`/Towers/download-format/${projectId}`, {
      responseType: 'blob', // Vital para descargar archivos
      headers: {
        'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    });

    // Crear la URL para descargar el archivo
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'Torres-formato.xlsx'); // Nombre del formato
    document.body.appendChild(link);
    link.click();

    link.remove();
    window.URL.revokeObjectURL(url);

  } catch (error) {
    console.error('Error al descargar el formato:', error);
    throw new Error('Error al descargar el formato de torres.');
  }
};

export const importTowerData = async (file: File, idProject: string) => {
    //try {
      const formData = new FormData();
      formData.append('file', file);
  
      const response = await apiClient.post(`/Towers/import/${idProject}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',  // Importante para manejar el envío de archivos
        },
      });
      /*if (response.status === 200) {
        alert('Importación exitosa');
      } else {
        alert('Error en la importación');
      }*/
    /*} catch (error) {
      console.error('Error al importar datos:', error);
      alert('Error al importar datos');
    }*/
};

export const exportTowerData = async (idProject: string) => {
    try {
      const response = await apiClient.get(`/Towers/${idProject}/export`, {
        responseType: 'blob',  // Para manejar archivos
        headers: {
          'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        },
      });
  
      // Crear una URL para descargar el archivo
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Torres.xlsx';  // Nombre del archivo exportado
      a.click();
    } catch (error) {
      console.error('Error al exportar los datos:', error);
    }
  };
  